import NAME from "./constants";

export const RESET_STATE = NAME + "/RESET_STATE";

export const GET = NAME + "/GET";
export const GET_REJECTED = NAME + "/GET_REJECTED";
export const GET_FULFILLED = NAME + "/GET_FULFILLED";


export const CREATE_TABLE = NAME + "/CREATE_TABLE";
export const CREATE_TABLE_REJECTED = NAME + "/CREATE_TABLE_REJECTED";
export const CREATE_TABLE_FULFILLED = NAME + "/CREATE_TABLE_FULFILLED";

export const DELETE_TABLE = NAME + "/DELETE_TABLE";
export const DELETE_TABLE_REJECTED = NAME + "/DELETE_TABLE_REJECTED";
export const DELETE_TABLE_FULFILLED = NAME + "/DELETE_TABLE_FULFILLED";

export const MODIFY_TABLE = NAME + "/MODIFY_TABLE";
export const MODIFY_TABLE_REJECTED = NAME + "/MODIFY_TABLE_REJECTED";
export const MODIFY_TABLE_FULFILLED = NAME + "/MODIFY_TABLE_FULFILLED";

export const CREATE_FIELD = NAME + "/CREATE_FIELD";
export const CREATE_FIELD_REJECTED = NAME + "/CREATE_FIELD_REJECTED";
export const CREATE_FIELD_FULFILLED = NAME + "/CREATE_FIELD_FULFILLED";

export const DELETE_FIELD = NAME + "/DELETE_FIELD";
export const DELETE_FIELD_REJECTED = NAME + "/DELETE_FIELD_REJECTED";
export const DELETE_FIELD_FULFILLED = NAME + "/DELETE_FIELD_FULFILLED";

export const MODIFY_FIELD = NAME + "/MODIFY_FIELD";
export const MODIFY_FIELD_REJECTED = NAME + "/MODIFY_FIELD_REJECTED";
export const MODIFY_FIELD_FULFILLED = NAME + "/MODIFY_FIELD_FULFILLED";

export const MODIFY_FIELD_OPTION = NAME + "/MODIFY_FIELD_OPTION";
export const MODIFY_FIELD_OPTION_REJECTED = NAME + "/MODIFY_FIELD_OPTION_REJECTED";
export const MODIFY_FIELD_OPTION_FULFILLED = NAME + "/MODIFY_FIELD_OPTION_FULFILLED";

export const GET_FIELDS = NAME + "/GET_FIELDS";
export const GET_FIELDS_REJECTED = NAME + "/GET_FIELDS_REJECTED";
export const GET_FIELDS_FULFILLED = NAME + "/GET_FIELDS_FULFILLED";

export const UPDATE = NAME + "/UPDATE";
export const UPDATE_REJECTED = NAME + "/UPDATE_REJECTED";
export const UPDATE_FULFILLED = NAME + "/UPDATE_FULFILLED";